import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { API_URL } from "../config";

export default function ResetPassword({ onLoginRequest }) {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async e => {
    e.preventDefault();
    setError("");
    if (password.length < 8) { setError("Пароль должен быть не короче 8 символов"); return; }
    if (password !== confirm) { setError("Пароли не совпадают"); return; }
    setLoading(true);
    try {
      const r = await fetch(`${API_URL}/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(data.detail || "Не удалось сменить пароль. Попробуйте позже.");
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <section style={{ maxWidth: 480, textAlign: "center", margin: "40px auto" }}>
        <CheckCircle2 size={44} color="#15803d" />
        <h1 style={{ color: "#15803d", marginTop: 12, fontSize: "1.4rem" }}>Пароль изменён</h1>
        <p style={{ color: "#666" }}>Теперь можно войти с новым паролем.</p>
        <button type="button" className="auth-submit-btn" style={{ maxWidth: 240 }} onClick={onLoginRequest}>Войти</button>
      </section>
    );
  }

  return (
    <section style={{ maxWidth: 420, margin: "40px auto" }}>
      <h1 className="section-title">Новый пароль</h1>
      {!token ? (
        <p>Ссылка неполная. Запросите новую в окне входа: «Забыли пароль?». <Link to="/">На главную</Link></p>
      ) : (
        <form onSubmit={submit} className="auth-form">
          {error && <div className="auth-error">{error}</div>}
          <label htmlFor="rp-new">Новый пароль (не короче 8 символов)</label>
          <input id="rp-new" type="password" value={password} onChange={e => setPassword(e.target.value)}
            required className="auth-input" autoComplete="new-password" autoFocus />
          <label htmlFor="rp-confirm">Повторите пароль</label>
          <input id="rp-confirm" type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
            required className="auth-input" autoComplete="new-password" />
          <button type="submit" disabled={loading} className="auth-submit-btn">
            {loading ? "Сохраняем…" : "Сохранить пароль"}
          </button>
        </form>
      )}
    </section>
  );
}
